module.exports = __webpack_public_path__ + "media/images/herospark-fc6eb32ec134eddb4c0b7a383280e1a8.svg";